import { Observer } from 'mobx-react-lite';
import React from 'react';

import { TableColumnHeader } from '@feathr/components';

import type { IData, ITemplateRow } from './TemplatesTable';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

const TemplateColumnViews = {
  id: 'views',
  Header: TableColumnHeader({
    title: 'Views',
  }),
  sortable: false,
  className: tableStyles.cellRight,
  width: 80,
  accessor({ template }: IData) {
    return (
      <Observer>
        {() => {
          const stats = template.get('stats_cache');
          return <>{stats?.num_views || 0}</>;
        }}
      </Observer>
    );
  },
  Cell({ original }: ITemplateRow) {
    return (
      <Observer>
        {() => {
          const { template } = original;
          const stats = template.get('stats_cache');
          return <>{(stats?.num_views || 0).toLocaleString()}</>;
        }}
      </Observer>
    );
  },
};

export default TemplateColumnViews;
